module.exports = [
	{
		"code": 130000,
		"type": "province",
		"name": "河北省",
		"parent_id": null
	},
	{
		"code": 150000,
		"type": "province",
		"name": "内蒙古自治区",
		"parent_id": null
	},
	{
		"code": 210000,
		"type": "province",
		"name": "辽宁省",
		"parent_id": null
	},
	{
		"code": 220000,
		"type": "province",
		"name": "吉林省",
		"parent_id": null
	},
	{
		"code": 230000,
		"type": "province",
		"name": "黑龙江省",
		"parent_id": null
	},
	{
		"code": 320000,
		"type": "province",
		"name": "江苏省",
		"parent_id": null
	},
	{
		"code": 330000,
		"type": "province",
		"name": "浙江省",
		"parent_id": null
	},
	{
		"code": 340000,
		"type": "province",
		"name": "安徽省",
		"parent_id": null
	},
	{
		"code": 350000,
		"type": "province",
		"name": "福建省",
		"parent_id": null
	},
	{
		"code": 360000,
		"type": "province",
		"name": "江西省",
		"parent_id": null
	},
	{
		"code": 370000,
		"type": "province",
		"name": "山东省",
		"parent_id": null
	},
	{
		"code": 410000,
		"type": "province",
		"name": "河南省",
		"parent_id": null
	},
	{
		"code": 420000,
		"type": "province",
		"name": "湖北省",
		"parent_id": null
	},
	{
		"code": 430000,
		"type": "province",
		"name": "湖南省",
		"parent_id": null
	},
	{
		"code": 440000,
		"type": "province",
		"name": "广东省",
		"parent_id": null
	},
	{
		"code": 450000,
		"type": "province",
		"name": "广西壮族自治区",
		"parent_id": null
	},
	{
		"code": 460000,
		"type": "province",
		"name": "海南省",
		"parent_id": null
	},
	{
		"code": 510000,
		"type": "province",
		"name": "四川省",
		"parent_id": null
	},
	{
		"code": 520000,
		"type": "province",
		"name": "贵州省",
		"parent_id": null
	},
	{
		"code": 530000,
		"type": "province",
		"name": "云南省",
		"parent_id": null
	},
	{
		"code": 540000,
		"type": "province",
		"name": "西藏自治区",
		"parent_id": null
	},
	{
		"code": 610000,
		"type": "province",
		"name": "陕西省",
		"parent_id": null
	},
	{
		"code": 620000,
		"type": "province",
		"name": "甘肃省",
		"parent_id": null
	},
	{
		"code": 630000,
		"type": "province",
		"name": "青海省",
		"parent_id": null
	},
	{
		"code": 640000,
		"type": "province",
		"name": "宁夏回族自治区",
		"parent_id": null
	},
	{
		"code": 650000,
		"type": "province",
		"name": "新疆维吾尔自治区",
		"parent_id": null
	},
	{
		"code": 140000,
		"type": "province",
		"name": "山西",
		"parent_id": null
	},
	{
		"code": 120000,
		"type": "province",
		"name": "天津",
		"parent_id": null
	},
	{
		"code": 110000,
		"type": "province",
		"name": "北京",
		"parent_id": null
	},
	{
		"code": 500000,
		"type": "province",
		"name": "重庆",
		"parent_id": null
	},
	{
		"code": 310000,
		"type": "province",
		"name": "上海",
		"parent_id": null
	},
	{
		"code": 710000,
		"type": "province",
		"name": "台湾",
		"parent_id": null
	},
	{
		"code": 810000,
		"type": "province",
		"name": "香港",
		"parent_id": null
	},
	{
		"code": 820000,
		"type": "province",
		"name": "澳门",
		"parent_id": null
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/config/data/provinces.json
// module id = 962
// module chunks = 3